import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 71BD315A-B0C1-4B8B-93CB-2A952C3A7C16
 * name mortar-pestle-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/mortar-pestle-plus.svg
 * tags
 * - Medical / Hospital 
 */
export const MortarPestlePlusIcon = createSvgIcon(<><path d="M16,14H13V17H11V14H8V12H11V9H13V12H16M21,5H18.35L19.5,1.85L17.15,1L15.69,5H3V7L5,13L3,19V21H21V19L19,13L21,7V5Z" /></>, 'MortarPestlePlusIcon');
export default MortarPestlePlusIcon